var map = {
	"./BBC_ProjectReith_WorldNews_Tile_Red_RGB.svg": 490,
	"./BBC_ProjectReith_WorldNews_Tile_Red_RGB@2x.png": 491,
	"./BBC_WorldNews_Tile.svg": 492,
	"./BlueSocialIcon/facebook.svg": 493,
	"./BlueSocialIcon/share-icon-bg.svg": 494,
	"./BlueSocialIcon/share-icon-black.svg": 495,
	"./BlueSocialIcon/share-icon-close.svg": 496,
	"./BlueSocialIcon/share-icon-open.svg": 497,
	"./BlueSocialIcon/share-icon.svg": 498,
	"./BlueSocialIcon/twitter.svg": 499
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 489;